export default "<div class=\"card\">\r\n    <div echarts id=\"bar\" class=\"chart-default\" [options]=\"options\"></div>\r\n</div>\r\n"